import { useTheme } from '@mui/material';
import { memo } from 'react';

import type { EFlightCategory } from '#shared';

export interface AirportPulseGradientProps {
  /**
   * The ID to use for the gradient. Defaults to 'airportPulseGradient'
   */
  id: string;
  flightCategory: EFlightCategory;
}

/**
 * SVG radial gradient component for airport pulse animation effect.
 * Creates a pulsing animation with color transitions from blue to transparent.
 */
export const AirportPulseGradient = memo<AirportPulseGradientProps>(
  ({ id, flightCategory }) => {
    const {
      palette: { flightCategory: fc },
    } = useTheme();
    const gradientColor = fc[flightCategory];
    return (
      <radialGradient id={id} x1="0%" y1="0%" x2="0%" y2="100%">
        <stop offset="0%">
          <animate
            attributeName="stop-color"
            attributeType="CSS"
            values={`${gradientColor}80; ${gradientColor}00; ${gradientColor}00`}
            dur="2s"
            repeatCount="indefinite"
          />
        </stop>
        <stop offset="50%">
          <animate
            attributeName="stop-color"
            attributeType="CSS"
            values={`${gradientColor}00; ${gradientColor}80; ${gradientColor}00`}
            dur="2s"
            repeatCount="indefinite"
          />
        </stop>
        <stop offset="100%">
          <animate
            attributeName="stop-color"
            attributeType="CSS"
            values={`${gradientColor}00; ${gradientColor}00; ${gradientColor}10`}
            dur="2s"
            repeatCount="indefinite"
          />
        </stop>
      </radialGradient>
    );
  },
);

AirportPulseGradient.displayName = 'AirportPulseGradient';
